import Home from './pages/Home'
import Dashboard from './pages/Dashboard'
import AddItem from './pages/AddItem'
import OnBoarding from './pages/OnBoarding'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import { useState } from "react";


const App = () => {
    const [, setAuthToken] = useState(null);
    const addAuthToken = (prevToken) => {
      setAuthToken((prevToken))
    }
    return (
    <Router>
      <Routes>
        <Route path={""} element={<Home addAuthToken={addAuthToken}/>}/>
          <Route path={"/dashboard"} element={<Dashboard/>}/>
          <Route path={"/additem/:id"} element={<AddItem/>}/>
          <Route path={"/onboarding/:edit"} element={<OnBoarding/>}/>
      </Routes>
    </Router>
  )
}

export default App
